module.exports = __webpack_public_path__ + "img/Color 534.6e8ec6af.jpg";